export default "__VITE_ASSET__1EWdr8CJ__"